export default class RemovedMatchesModifier {
    constructor(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }

    modify(content) {
        if (content.events === undefined) {
            return;
        }

        const matches = content.events.remove;

        if (matches !== undefined) {
            for (let i = 0; i < matches.length; i++) {
                matches[i] = this._modelKeyRepository.removeMatch(matches[i]);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/RemovedMatchesModifier.js